/* MEEKO — scripts du thème (JavaScript natif, sans dépendance) */
(() => {
  'use strict';

  const T = window.MeekoTheme || { routes: { root: '/', cart: '/cart' }, strings: {}, cartType: 'drawer' };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(message) {
    if (!message) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
    }
    // Dans un tiroir/dialogue ouvert, le message doit être dans le dialogue (couche supérieure)
    const host = document.querySelector('dialog[open]') || document.body;
    if (toastEl.parentNode !== host) host.appendChild(toastEl);
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2800);
  }

  /* ---------- Dialogues génériques ---------- */
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    const focusTarget = dialog.querySelector('[autofocus]') || dialog.querySelector('input, button, a');
    if (focusTarget) setTimeout(() => focusTarget.focus(), 30);
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-dialog]');
    if (opener) {
      e.preventDefault();
      openDialog(document.getElementById(opener.dataset.openDialog));
      return;
    }
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) {
      e.preventDefault();
      closeDialog(closer.closest('dialog'));
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.open && !e.target.classList.contains('ugc-viewer')) {
      const r = e.target.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(e.target);
    }
  });
  document.addEventListener('close', (e) => {
    if (e.target.tagName === 'DIALOG' && !$$('dialog[open]').length) document.body.classList.remove('overflow-hidden');
  }, true);

  /* ---------- Panier ---------- */
  const Cart = {
    drawer() { return document.getElementById('CartDrawer'); },
    async refresh(open) {
      const drawer = this.drawer();
      try {
        const res = await fetch(`${root}?sections=cart-drawer`);
        const data = await res.json();
        if (drawer && data['cart-drawer']) {
          const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer-inner]');
          const current = drawer.querySelector('[data-cart-drawer-inner]');
          if (fresh && current) current.replaceWith(fresh);
        }
      } catch (err) { /* le tiroir garde son contenu */ }
      await this.updateCount();
      if (open && drawer) openDialog(drawer);
    },
    async updateCount() {
      try {
        const cart = await (await fetch(`${root}cart.js`)).json();
        $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        return cart;
      } catch (err) { return null; }
    },
    async add(formData) {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Erreur');
      document.dispatchEvent(new CustomEvent('cart:added', { detail: json }));
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return json; }
      if (T.cartType === 'drawer' && this.drawer()) {
        await this.refresh(true);
      } else {
        window.location.href = T.routes.cart;
      }
      return json;
    },
    busy: false,
    async change(ref, quantity) {
      // ref = clé de la ligne (item.key) : reste valable même si une autre ligne disparaît entre-temps
      if (this.busy) return;
      this.busy = true;
      document.documentElement.classList.add('cart-busy');
      const payload = typeof ref === 'string' ? { id: ref, quantity } : { line: ref, quantity };
      let ok = true;
      try {
        const res = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        if (!res.ok) { ok = false; const j = await res.json().catch(() => ({})); toast(j.description || j.message); }
        if (document.body.classList.contains('template-cart')) {
          if (ok) { window.location.reload(); return; }
        }
        await this.refresh(false);
      } finally {
        this.busy = false;
        document.documentElement.classList.remove('cart-busy');
      }
    }
  };
  window.MeekoCart = Cart;

  // Ouvrir le tiroir depuis l'icône panier
  document.addEventListener('click', (e) => {
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && T.cartType === 'drawer' && Cart.drawer()) {
      e.preventDefault();
      openDialog(Cart.drawer());
    }
  });

  // Formulaires d'ajout (fiche produit, cartes, suggestions)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      const picker = document.querySelector(`[data-variant-picker="${form.dataset.section || ''}"]`);
      if (picker) picker.dispatchEvent(new CustomEvent('variant:missing'));
      return;
    }
    if (form.dataset.busy) return; // évite un double ajout en cas de double clic
    form.dataset.busy = '1';
    // Liste déroulante de tailles (suggestions du panier) : précommande selon la taille choisie
    const sel = form.querySelector('select[name="id"]');
    const opt = sel && sel.selectedOptions ? sel.selectedOptions[0] : null;
    if (opt) {
      const plan = form.querySelector('[data-selling-plan]');
      if (plan) { plan.value = opt.dataset.sellingPlan || ''; plan.disabled = !opt.dataset.sellingPlan; }
      $$('[data-preorder-prop]', form).forEach((input) => { input.disabled = !opt.dataset.preorder; });
    }
    const button = form.querySelector('[type="submit"]');
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
    try {
      await Cart.add(new FormData(form));
    } catch (err) {
      toast(err.message);
    } finally {
      delete form.dataset.busy;
      if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
    }
  });

  // Ajout rapide par taille (cartes produit)
  document.addEventListener('click', async (e) => {
    const chip = e.target.closest('[data-quick-add]');
    if (!chip) return;
    e.preventDefault();
    if (chip.dataset.busy) return;
    chip.dataset.busy = '1';
    const fd = new FormData();
    fd.append('id', chip.dataset.quickAdd);
    fd.append('quantity', '1');
    // Précommande : même plan de vente et propriétés que la fiche produit
    if (chip.dataset.sellingPlan) fd.append('selling_plan', chip.dataset.sellingPlan);
    if (chip.dataset.preorder) {
      fd.append('properties[_is_preorder]', 'Modèle en précommande');
      fd.append('properties[_preorder_locale]', chip.dataset.preorder);
      if (chip.dataset.preorderDate) fd.append('properties[Expédition prévue]', chip.dataset.preorderDate);
    }
    chip.classList.add('is-loading');
    try { await Cart.add(fd); } catch (err) { toast(err.message); } finally { chip.classList.remove('is-loading'); delete chip.dataset.busy; }
  });

  // Quantités et suppression dans le panier
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (btn) {
      e.preventDefault();
      const line = parseInt(btn.dataset.line, 10);
      const scope = btn.closest('[data-cart-drawer-inner]') || document;
      const input = scope.querySelector(`[data-qty-input][data-line="${line}"]`);
      const current = input ? parseInt(input.value, 10) || 0 : 0;
      const next = btn.dataset.qtyChange === 'remove' ? 0 : Math.max(0, current + parseInt(btn.dataset.qtyChange, 10));
      Cart.change(btn.dataset.key || line, next);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (input) Cart.change(input.dataset.key || parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Sélecteur de variantes (fiche produit) ---------- */
  class VariantPicker {
    constructor(el) {
      this.el = el;
      this.section = el.dataset.variantPicker;
      this.form = document.querySelector(`form[data-product-form][data-section="${this.section}"]`);
      this.variants = JSON.parse(el.querySelector('[data-variants-json]').textContent);
      this.error = el.querySelector('[data-variant-error]');
      this.soldOut = !this.variants.some((v) => v.available);
      this.requireChoice = el.dataset.requireChoice === 'true';
      this.priceEl = document.querySelector(`[data-price-wrap="${this.section}"]`);
      this.buttons = $$(`[data-atc="${this.section}"]`);
      el.addEventListener('change', () => this.onChange());
      el.addEventListener('variant:missing', () => this.showError());
      if (this.requireChoice && !new URLSearchParams(window.location.search).get('variant')) {
        $$('input[type="radio"]', el).forEach((input) => {
          if (input.closest('[data-option-group]') && input.closest('[data-option-group]').dataset.optionSize === 'true') input.checked = false;
        });
        this.setVariant(null);
      } else {
        this.onChange(true);
      }
    }
    selectedOptions() {
      return $$('[data-option-group]', this.el).map((group) => {
        const checked = group.querySelector('input:checked');
        const select = group.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      });
    }
    onChange(initial) {
      const options = this.selectedOptions();
      if (options.some((o) => o === null)) { this.setVariant(null); return; }
      const variant = this.variants.find((v) => v.options.every((o, i) => o === options[i]));
      this.setVariant(variant || false, initial);
    }
    setVariant(variant, initial) {
      const idInput = this.form ? this.form.querySelector('[name="id"]') : null;
      if (this.error) this.error.hidden = true;
      this.el.closest('.product__info')?.querySelectorAll('[data-selected-option]').forEach((node) => {
        const idx = parseInt(node.dataset.selectedOption, 10);
        node.textContent = variant ? variant.options[idx] : '';
      });
      if (!variant) this.setPreorder(null);
      if (variant === null) {
        if (idInput) idInput.value = '';
        // Produit entièrement épuisé : on l'annonce tout de suite, sans faire choisir une taille
        if (this.soldOut) this.updateButtons(T.strings.soldOut || 'Épuisé', true);
        else this.updateButtons(T.strings.chooseSize || 'Choisir ma taille', false);
        return;
      }
      if (variant === false) {
        if (idInput) idInput.value = '';
        this.updateButtons(T.strings.unavailable || 'Indisponible', true);
        return;
      }
      if (idInput) idInput.value = variant.id;
      this.setPreorder(variant);
      if (this.priceEl && variant.price_html) this.priceEl.innerHTML = variant.price_html;
      const addLabel = variant.preorder ? (T.strings.preorder || 'Précommander') : ((this.buttons[0] && this.buttons[0].dataset.addLabel) || T.strings.addToCart || 'Ajouter au panier');
      this.updateButtons(variant.available ? `${addLabel}${variant.size_label ? ' · ' + variant.size_label : ''}` : (T.strings.soldOut || 'Épuisé'), !variant.available);
      $$('[data-sticky-variant]').forEach((n) => { n.textContent = variant.title; });
      if (!initial && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, section: this.section } }));
    }
    setPreorder(variant) {
      if (!this.form) return;
      const plan = this.form.querySelector('[data-selling-plan]');
      if (plan) { plan.value = variant && variant.selling_plan ? variant.selling_plan : ''; plan.disabled = !(variant && variant.selling_plan); }
      $$('[data-preorder-prop]', this.form).forEach((input) => { input.disabled = !(variant && variant.preorder); });
      const note = this.form.querySelector('[data-preorder-note]');
      if (note) note.hidden = !(variant && variant.preorder && (variant.selling_plan || note.hasAttribute('data-ship-date')));
    }
    updateButtons(label, disabled) {
      this.buttons.forEach((b) => {
        const span = b.querySelector('[data-atc-label]') || b;
        span.textContent = label;
        if (disabled) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled');
      });
    }
    showError() {
      if (this.error) {
        this.error.hidden = false;
        this.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
  $$('[data-variant-picker]').forEach((el) => new VariantPicker(el));

  // Barre d'achat collante (mobile)
  $$('[data-sticky-atc]').forEach((bar) => {
    const target = document.querySelector(bar.dataset.stickyAtc);
    if (!target || !('IntersectionObserver' in window)) return;
    // Visible dès que le bouton principal n'est plus à l'écran, une fois le premier écran passé
    // (utile sur les pages de vente où le bloc d'achat est plus bas).
    let targetVisible = true;
    const update = () => {
      const on = !targetVisible && window.scrollY > window.innerHeight * 0.8;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('has-sticky-atc', on && window.innerWidth < 750);
    };
    new IntersectionObserver(([entry]) => { targetVisible = entry.isIntersecting; update(); }).observe(target);
    window.addEventListener('scroll', update, { passive: true });
    bar.querySelector('[data-sticky-submit]')?.addEventListener('click', (e) => {
      e.preventDefault();
      const form = document.querySelector(`form[data-product-form][data-section="${bar.dataset.section}"]`);
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* ---------- Sliders ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-slider-dir]');
    if (!btn) return;
    const slider = document.getElementById(btn.dataset.sliderTarget);
    if (!slider) return;
    const item = slider.firstElementChild;
    const step = item ? item.getBoundingClientRect().width + 20 : slider.clientWidth * 0.8;
    slider.scrollBy({ left: step * (btn.dataset.sliderDir === 'next' ? 1 : -1), behavior: 'smooth' });
  });

  // Points de la galerie mobile
  $$('[data-gallery]').forEach((gallery) => {
    const dots = $$('[data-gallery-dot]', gallery.parentElement);
    if (!dots.length) return;
    gallery.addEventListener('scroll', () => {
      const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
    }, { passive: true });
  });

  /* ---------- Vidéos créateurs ---------- */
  const viewer = document.getElementById('UgcViewer');
  const Ugc = {
    items: [], index: 0, muted: true,
    open(items, index) {
      if (!viewer) return;
      this.items = items; this.index = index;
      openDialog(viewer);
      this.render();
    },
    render() {
      const item = this.items[this.index];
      if (!item) return;
      const video = $('[data-ugc-video]', viewer);
      const bars = $('[data-ugc-bars]', viewer);
      bars.innerHTML = this.items.map((_, i) => `<span class="${i < this.index ? 'is-done' : ''}"><i></i></span>`).join('');
      $('[data-ugc-who]', viewer).textContent = item.who || '';
      video.muted = this.muted;
      video.poster = item.poster || '';
      video.src = item.src || '';
      video.play().catch(() => {});
      const box = $('[data-ugc-product]', viewer);
      if (item.product) {
        box.hidden = false;
        $('[data-ugc-product-title]', viewer).textContent = item.product.title;
        $('[data-ugc-product-price]', viewer).textContent = item.product.price;
        const img = $('[data-ugc-product-image]', viewer);
        img.src = item.product.image || '';
        img.alt = item.product.title;
        $('[data-ugc-product-link]', viewer).href = item.product.url;
      } else {
        box.hidden = true;
      }
    },
    go(delta) {
      if (!this.items.length) return;
      this.index = (this.index + delta + this.items.length) % this.items.length;
      this.render();
    }
  };
  if (viewer) {
    const video = $('[data-ugc-video]', viewer);
    video.addEventListener('timeupdate', () => {
      const bar = $$('[data-ugc-bars] span', viewer)[Ugc.index];
      if (bar && video.duration) bar.querySelector('i').style.width = `${(video.currentTime / video.duration) * 100}%`;
    });
    video.addEventListener('ended', () => { if (Ugc.index < Ugc.items.length - 1) Ugc.go(1); else closeDialog(viewer); });
    viewer.addEventListener('click', (e) => {
      if (e.target.closest('[data-ugc-next]')) Ugc.go(1);
      else if (e.target.closest('[data-ugc-prev]')) Ugc.go(-1);
      else if (e.target.closest('[data-ugc-close]')) closeDialog(viewer);
      else if (e.target.closest('[data-ugc-mute]')) {
        Ugc.muted = !Ugc.muted; video.muted = Ugc.muted;
        viewer.classList.toggle('is-unmuted', !Ugc.muted);
      }
    });
    viewer.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') Ugc.go(1);
      if (e.key === 'ArrowLeft') Ugc.go(-1);
    });
    viewer.addEventListener('close', () => { video.pause(); video.removeAttribute('src'); video.load(); });
  }
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-ugc-open]');
    if (!card) return;
    e.preventDefault();
    const dataEl = document.querySelector(`[data-ugc-data="${card.dataset.ugcGroup}"]`);
    if (!dataEl) return;
    Ugc.open(JSON.parse(dataEl.textContent), parseInt(card.dataset.ugcOpen, 10) || 0);
  });
  // Lecture automatique des aperçus quand ils sont visibles
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (entry.isIntersecting) v.play().catch(() => {}); else v.pause();
      });
    }, { threshold: 0.4 });
    $$('video[data-autoplay-preview]').forEach((v) => io.observe(v));
  }

  /* ---------- Section vidéo ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-play]');
    if (!btn) return;
    const wrap = btn.closest('[data-video-wrap]');
    const tpl = wrap && wrap.querySelector('template');
    if (!tpl) return;
    wrap.innerHTML = '';
    wrap.appendChild(tpl.content.cloneNode(true));
    const v = wrap.querySelector('video');
    if (v) v.play().catch(() => {});
  });

  /* ---------- Recommandations produit ---------- */
  $$('[data-recommendations-url]').forEach(async (el) => {
    try {
      const html = await (await fetch(el.dataset.recommendationsUrl)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations-inner]');
      if (inner && inner.children.length) {
        el.querySelector('[data-recommendations-inner]').replaceWith(inner);
        el.hidden = false;
      }
    } catch (err) { /* reste masqué */ }
  });

  /* ---------- Recherche instantanée ---------- */
  $$('[data-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    const results = document.getElementById(form.dataset.predictiveSearch);
    if (!input || !results) return;
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = `${root}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection&resources[limit]=8`;
          const html = await (await fetch(url)).text();
          if (q !== input.value.trim()) return; // une recherche plus récente est en cours
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { results.innerHTML = ''; }
      }, 220);
    });
  });

  /* ---------- Filtres de collection (sans rechargement) ---------- */
  let facetsOpener = null;
  const syncFacetToggles = (panel, open) => {
    $$(`button[data-facets-toggle="${panel.id}"]`).forEach((b) => {
      b.setAttribute('aria-controls', panel.id);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };
  const closeFacets = (panel) => {
    if (!panel) return;
    panel.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    syncFacetToggles(panel, false);
    if (facetsOpener && document.contains(facetsOpener)) facetsOpener.focus({ preventScroll: true });
    facetsOpener = null;
  };
  $$('.facets[id]').forEach((panel) => syncFacetToggles(panel, false));
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-facets-toggle]');
    if (!t) return;
    const panel = document.getElementById(t.dataset.facetsToggle);
    if (!panel) return;
    const open = !panel.classList.contains('is-open');
    if (!open) { closeFacets(panel); return; }
    facetsOpener = t;
    panel.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    syncFacetToggles(panel, true);
    const first = panel.querySelector('.facets__head button, input, summary');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 30);
  });
  // Menus de tri : fermeture au clic extérieur et avec Échap
  document.addEventListener('click', (e) => {
    $$('details[data-sort][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('details[data-sort][open]').forEach((d) => { d.open = false; $('summary', d).focus(); });
    closeFacets($('.facets.is-open'));
  });

  const initPriceRange = (ctx) => {
    $$('[data-price-range]', ctx).forEach((box) => {
      const max = parseFloat(box.dataset.max) || 1;
      const tMin = $('[data-price-thumb="min"]', box);
      const tMax = $('[data-price-thumb="max"]', box);
      const fMin = $('[data-price-field="min"]', box);
      const fMax = $('[data-price-field="max"]', box);
      const fill = $('[data-price-fill]', box);
      if (!tMin || !tMax || !fMin || !fMax) return;
      const paint = () => {
        const a = parseFloat(tMin.value) || 0;
        const b = parseFloat(tMax.value) || max;
        fill.style.left = `${(a / max) * 100}%`;
        fill.style.right = `${100 - (b / max) * 100}%`;
        tMin.style.zIndex = a > max * 0.9 ? '3' : '';
      };
      const fromThumbs = (e) => {
        let a = parseFloat(tMin.value);
        let b = parseFloat(tMax.value);
        if (a > b) {
          if (e.target === tMin) { a = b; tMin.value = a; } else { b = a; tMax.value = b; }
        }
        fMin.value = a > 0 ? a : '';
        fMax.value = b < max ? b : '';
        paint();
      };
      const fromFields = () => {
        tMin.value = fMin.value || 0;
        tMax.value = fMax.value || max;
        paint();
      };
      tMin.addEventListener('input', fromThumbs);
      tMax.addEventListener('input', fromThumbs);
      fMin.addEventListener('input', fromFields);
      fMax.addEventListener('input', fromFields);
      paint();
    });
  };

  $$('[data-collection]').forEach((wrap) => {
    const sectionId = wrap.dataset.sectionId;
    let controller;
    let timer;
    initPriceRange(wrap);

    const urlFromForm = (form) => {
      const params = new URLSearchParams();
      const range = $('[data-price-range]', form);
      const pmax = range ? parseFloat(range.dataset.max) : null;
      new FormData(form).forEach((v, k) => {
        if (v === '') return;
        if (k.endsWith('price.gte') && parseFloat(v) <= 0) return;
        if (k.endsWith('price.lte') && pmax !== null && parseFloat(v) >= pmax) return;
        params.append(k, v);
      });
      const qs = params.toString();
      return form.getAttribute('action') + (qs ? `?${qs}` : '');
    };

    const render = async (url, push = true) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const results = $('[data-results]', wrap);
      if (results) results.classList.add('is-loading');
      const fetchUrl = new URL(url, window.location.href);
      fetchUrl.searchParams.set('section_id', sectionId);
      try {
        const res = await fetch(fetchUrl.toString(), { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const openState = {};
        $$('[data-facet]', wrap).forEach((d) => { openState[d.dataset.facet] = d.open; });
        const activeId = document.activeElement && wrap.contains(document.activeElement) ? document.activeElement.id : '';

        const body = $('[data-facets-body]', wrap);
        const newBody = $('[data-facets-body]', doc);
        if (body && newBody) {
          body.innerHTML = newBody.innerHTML;
          $$('[data-facet]', body).forEach((d) => {
            if (d.dataset.facet in openState) d.open = openState[d.dataset.facet];
          });
          initPriceRange(body);
        }
        const newResults = $('[data-results]', doc);
        if (results && newResults) results.replaceWith(newResults);
        const panel = $('.facets[id]', wrap);
        if (panel) syncFacetToggles(panel, panel.classList.contains('is-open'));

        if (activeId) {
          const el = document.getElementById(activeId);
          if (el) el.focus({ preventScroll: true });
        }
        if (push) window.history.pushState({ facets: true }, '', url);
        const status = $('[data-results-status]', wrap);
        const newStatus = $('[data-results-status]', doc);
        if (status && newStatus) status.textContent = newStatus.textContent;
        const current = $('[data-results]', wrap);
        if (current && !$('.facets.is-open', wrap)) {
          const top = current.getBoundingClientRect().top;
          if (top < 0) window.scrollTo({ top: window.scrollY + top - 110, behavior: 'smooth' });
        }
      } catch (err) {
        if (err.name !== 'AbortError') window.location.href = url;
      } finally {
        const current = $('[data-results]', wrap);
        if (current) current.classList.remove('is-loading');
      }
    };

    wrap.addEventListener('change', (e) => {
      const form = e.target.closest('[data-facets-form]');
      if (!form) return;
      clearTimeout(timer);
      timer = setTimeout(() => render(urlFromForm(form)), e.target.type === 'range' ? 150 : 300);
    });
    wrap.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-facets-form]');
      if (!form) return;
      e.preventDefault();
      clearTimeout(timer);
      render(urlFromForm(form));
    });
    wrap.addEventListener('click', (e) => {
      const link = e.target.closest('a[data-facet-link]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      const menu = link.closest('details[data-sort]');
      if (menu) menu.open = false;
      render(link.href);
    });
    window.addEventListener('popstate', () => render(window.location.href, false));
  });

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', () => {
    $$('[data-variant-picker]').forEach((el) => { if (!el._init) { el._init = true; new VariantPicker(el); } });
  });
})();
